export function getCookie(name) {
	var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	if (arr == document.cookie.match(reg)) {
		return (arr[2])
	}
	else {
		return null
	}
};
export function setCookie(name) {
	var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	if (arr == document.cookie.match(reg)) {
		return (arr[2]);
	}
	else {
		return null;
	}
};
export function delCookie(name) {
	var exp = new Date();
	exp.setTime(exp.getTime() - 1);
	var cval = getCookie(name);
	if (cval != null) {
		document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
	}
};
export function debounce(fn, wait) {
	let timer, startTimeStamp = 0;
	let context, args;
	var run = (timerInterval) => {
		timer = setTimeout(() => {
			let now = (new Date()).getTime();
			let interval = now - startTimeStamp
			if (interval < timerInterval) { // the timer start time has been reset，so the interval is less than timerInterval
				startTimeStamp = now;
				run(wait - interval);  // reset timer for left time 
			} else {
				fn.apply(context, args);
				clearTimeout(timer);
				timer = null;
			}
		}, timerInterval);
	}
	return function () {
		context = this;
		args = arguments;
		let now = (new Date()).getTime();
		startTimeStamp = now; // set timer start time
		if (!timer) {
			fn.apply(context, args);
			run(wait);    // last timer alreay executed, set a new timer
		}
	}
}
export function throttling(fn, wait, immediate) {
	let timer, timeStamp = 0;
	let context, args;

	let run = () => {
		timer = setTimeout(() => {
			if (!immediate) {
				fn.apply(context, args);
			}
			clearTimeout(timer);
			timer = null;
		}, wait);
	}
	return function () {
		context = this;
		args = arguments;
		if (!timer) {
			if (immediate) {
				fn.apply(context, args);
			}
			run();
		} else {
			console.log("throttle, ignore");
		}
	}
}

export function json2fromData(json) {
	const formData = new FormData();
	Object.keys(json).forEach((key) => {
		if (json[key] instanceof Array) {
			formData.append(key + '[]', json[key]);
		} else {
			formData.append(key, json[key]);
		}
	});
	return formData
}
//生成单号
export function generateNumber(name) {
	var randomNum = Math.floor(Math.random() * 9999);
	var myDate = new Date();
	var tY = myDate.getFullYear();
	var tM = myDate.getMonth() + 1;
	if (tM >= 1 && tM <= 9) {
		tM = "0" + tM;
	}
	var tD = myDate.getDate();
	if (tD >= 1 && tD <= 9) {
		tD = "0" + tD;
	}
	var oddNumbers = name + tY + tM + tD + randomNum;
	return oddNumbers
};


/**
 * @description blob转换处理
 * @param {string}   url 传 url 和 一个回调 
 * @param {function} callback    false  说明已是blob 或者 当前img 无 src
 *                              返回值  转成的blob临时地址(成功)
 *                              原图的img src  (转换失败 返回原图)
*/
export const getUrlBlob = (url, callback) => {
    const str = url.substring(0, 50)
    // 避免重复加载
    if (str.includes('blob:')) {
        return callback(false)
    }
    // 避免img未有src属性的情况，导致未返回
    if (!str) {
        return callback(false)
    }
    let canvas = document.createElement("canvas")
    let ctx = canvas.getContext("2d")
    let img = new Image
    img.crossOrigin = 'Anonymous'
    img.src = url
    img.onload = function () {
        canvas.height = img.height
        canvas.width = img.width
        ctx.drawImage(img, 0, 0)
        try {
            canvas.toBlob((blob) => {
                callback(URL.createObjectURL(blob))
            })
        } catch (err) {
            callback(img.src)
            console.error('转换失败，使用原图', err)
        }
        canvas = null
    }
    // img.error = function () {
    //     callback(img.src)
    //     console.error('转换失败，使用原图', img.error)
    // }
}
/**
 * @description 截图操作
 * @param {element} el       截图的dom区域
 * @param {function} success  成功  返回完整的base64
 * @param {function} error    错误  返回err信息
*/
export function IsRender(el, success, error) {
    // setTimeout(() => {
    //     var width = el.offsetWidth; //获取dom 宽度
    //     var height = el.offsetHeight; //获取dom 高度
    //     var canvas = document.createElement("canvas"); //创建一个canvas节点
    //     // 兼容清晰度
    //     const scale = window.devicePixelRatio; //定义任意放大倍数 支持小数
    //     canvas.width = width * scale; //定义canvas 宽度 * 缩放
    //     canvas.height = height * scale; //定义canvas高度 *缩放
    //     var context = canvas.getContext('2d');
    //     // 去图片锯齿 官网
    //     context.mozImageSmoothingEnabled = false;
    //     context.webkitImageSmoothingEnabled = false;
    //     context.msImageSmoothingEnabled = false;
    //     context.imageSmoothingEnabled = false;
    //     // options配置
    //     var opts = {
    //         scale: scale,
    //         canvas: canvas,
    //         logging: false,
    //         width: width,
    //         height: height,
    //         dpi: 300,
    //         useCORS: true,
    //         backgroundColor: "transparent",
    //         allowTaint: false,
    //     };
    //     // 进行截图
    //     html2canvas(el, opts)
    //         .then(canvas => {
    //             try {
    //                 const base64 = canvas.toDataURL('image/png');
    //                 success && success.call(this, base64)
    //             } catch (err) {
    //                 error && error(err)
    //             }
    //         })
    //         .catch(err => {
    //             error && error(err)
    //         })
    // }, 500)
}